// Pip positions for one half of a domino (0–6), on a unit square (0..1,
// x right, y down). Shared by the DOM tiles (SVG), the 3D face atlas and the
// VR panel textures, so every view draws the same faces.

const L = 0.25, M = 0.5, R = 0.75;
export const PIP_LAYOUT: [number, number][][] = [
  [],
  [[M, M]],
  [[L, L], [R, R]],
  [[L, L], [M, M], [R, R]],
  [[L, L], [R, L], [L, R], [R, R]],
  [[L, L], [R, L], [M, M], [L, R], [R, R]],
  [[L, L], [R, L], [L, M], [R, M], [L, R], [R, R]],
];

/** Pip radius as a fraction of the half's side. */
export const PIP_R = 0.095;

/** "6-4" → [6, 4]. */
export const tilePips = (t: string): [number, number] => [Number(t[0]), Number(t[2])];
